var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.57,174c-10.54-21.75-15.09-23.64-22.1-24s-23.56-2.42-42,.53c0,0-51.44-.9-91.24,23.21-41.55,25.17-61.77,47.28-64.6,58.74s-12.49,41.32-17.07,58.44-7.7,32.2-1.86,46.06c3.53,8.38,7.29,10.9,12.12,10.86a34.79,34.79,0,0,1-1.95-4.11c-4.8-11.89-4.22-28.9,1.26-30s8.75,10.29,12.06,22.71a49.39,49.39,0,0,0,2.66,8c8.19-3.09,21.31-10,38.75-17.18a112.16,112.16,0,0,1-.11-32.92c2.58-17.07,13.49-20.84,18.24-10.45,3.93,8.56,5.39,27.72,5.78,34.18,7-2.41,12.86-4,16.47-4.22,0,0,59.68-13.48,103.67-14.56s66-2.13,66-2.13S355.11,195.71,344.57,174Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.8,242.53a22.68,22.68,0,0,1,4.62,1.41,12.08,12.08,0,0,1,3.31,2.4l5-6.61s-7.33-3.07-8.72-4.94l-1.38-1.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.75,268.36s-.59,5.18-1.28,5.91-18.89-14.56-20-16-.35-6.58,0-8.19-.24-2.49-2-1.38-1.29,5.73-1.29,5.73-5.37-1.29-6.44-1.44-2,1.18-1.84,2.24,1.57,1.15,1.57,1.15a8,8,0,0,0,.29,4.62c.94,1.94,2,3.16,4,3.64a33.33,33.33,0,0,0,6.24.38s9.3,8.86,12,12.17,8.39,7.81,11.22,7,5.53-14.94,5.53-14.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.23,234.28s.61,1.51,1.63,4.16,6.5,8.24,9.18,8.56,5.89-9.42,6.4-11.43c.17-.66.34-1.72.34-1.72s3.37-1.59,2.59-3.51-2.36-2.8-3.11-2.21-.88,3.08-2,3.1-1.73-.33-2.72-1.65S104.29,231,103.23,234.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.9,355.74s30.67-8,54.67-48c26.9-44.84,15.36-123.08-20.47-161.09C374.86,111.4,301.27,105.2,258.57,122.4c-40.35,16.26-71.34,55.34-96,60.67s-55.34-3.33-88.67,33.33-26,119.34,12,146.67,94-4.67,142.67-26.67S285.23,362.4,373.9,355.74Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.9,355.74s30.67-8,54.67-48c26.9-44.84,15.36-123.08-20.47-161.09C374.86,111.4,301.27,105.2,258.57,122.4c-40.35,16.26-71.34,55.34-96,60.67s-55.34-3.33-88.67,33.33-26,119.34,12,146.67,94-4.67,142.67-26.67S285.23,362.4,373.9,355.74Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.74,275v-.06c-8.16-2.71-20.68-1.79-22.54-.68a18.2,18.2,0,0,0-5,5,59.31,59.31,0,0,0-9.28,20.69l-88.75,8.25c-3.27-7.06-8.2-13.39-13.15-17.21a14.32,14.32,0,0,0-4.8-2.65,7.59,7.59,0,0,0-2.32.08c-3.22-9.33-7.78-18.33-13.48-18.9-12-1.2-32.94,2.82-38.65,14.46s-7.5,40.7-7.5,40.7l-4,4a46.48,46.48,0,0,0-11.92-14.75,14,14,0,0,0-4.8-2.65c-1-.28-5,.34-9.19,1.71-.17-.16-.33-.32-.51-.47-4-3.35-12.2-5.18-16.78,3.36s.92,24.71,3.66,28.37a18.4,18.4,0,0,0,4.92,4.73c3.23,8,9,18.2,17.88,18.67a21.25,21.25,0,0,0,16.43-6.46c5.76-6,6.38-14.43,4.21-22.68l.93-1.36s2.07,2.95,10,1.76a11.85,11.85,0,0,0,6.27-2.6c3.72,9.49,9.73,19,19.28,20.42a28.87,28.87,0,0,0,23.11-6.58,25.62,25.62,0,0,0,4.75-5.45,21.2,21.2,0,0,0,14.1-6.46,19.76,19.76,0,0,0,5.34-13.05l11.81-1.38a51.69,51.69,0,0,0,23.61,4.42,33.55,33.55,0,0,0,20.79-9l26.91-2.3c.45,10.43,4.2,20,13,25.27a27.15,27.15,0,0,0,22.6,2.41c12.41-4.16,15.35-22.6,16.15-33.81C378.06,292.8,372.32,277.55,363.74,275Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.44,350.94a11.15,11.15,0,0,1-3.85,3.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.29,327.24s1.19,13-3.24,21.25",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.8,341.6c-1.13,5-3.38,9.85-7.74,12",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.23,326.25s2,21.61-8.69,26.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.71,325.75s2,21.62-8.7,26.83",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.62,340.9a13.89,13.89,0,0,1-4.2,3.55",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.66,313.91s-.64,14.79-6.13,24.2",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.09,330.29c-1.8,5.69-4.68,11.21-9.23,13.61",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.54,312.81s-1.07,24.64-12.24,30.54",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,312.27s-1.07,24.63-12.24,30.54",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.35,364.31a10.83,10.83,0,0,1-3.29,3.24",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.93,343.28s2.82,11-.36,18.69",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16,355.09c-.45,4.45-2,8.93-5.87,11.39",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.37,341.14s4.7,18.25-4.86,24.26",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.59,340.06s4.71,18.25-4.86,24.27",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.06,319.83c2.38,13.61.89,25.25-3.31,26s-9.55-9.71-11.93-23.32-.89-25.25,3.32-26S186.68,306.21,189.06,319.83Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.94,320.12c.66,5.22.05,9.59-1.38,9.77s-3.11-3.9-3.77-9.12,0-9.6,1.38-9.78S186.28,314.9,186.94,320.12Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.91,307.64a34,34,0,0,1,.83-5.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,340.92a66.46,66.46,0,0,1-5.88-17.53,63.32,63.32,0,0,1-.91-13.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.29,
    cy: 342.56,
    rx: 5.68,
    ry: 18.39,
    transform: "translate(-86.93 45.9) rotate(-15.49)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.78,341.43c.95,3.72.9,6.94-.12,7.2s-2.6-2.55-3.55-6.26-.9-6.95.12-7.2S128.83,337.71,129.78,341.43Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.4,333.3a24.86,24.86,0,0,1,.13-3.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19,356.79a48.46,48.46,0,0,1-5.83-12.16,46.23,46.23,0,0,1-1.84-9.36",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.57,174c-10.54-21.75-15.09-23.64-22.1-24s-23.56-2.42-42,.53c0,0-51.44-.9-91.24,23.21-41.55,25.17-61.77,47.28-64.6,58.74s-12.49,41.32-17.07,58.44-7.7,32.2-1.86,46.06c3.53,8.38,7.29,10.9,12.12,10.86a34.79,34.79,0,0,1-1.95-4.11c-4.8-11.89-4.22-28.9,1.26-30s8.75,10.29,12.06,22.71a49.39,49.39,0,0,0,2.66,8c8.19-3.09,21.31-10,38.75-17.18a112.16,112.16,0,0,1-.11-32.92c2.58-17.07,13.49-20.84,18.24-10.45,3.93,8.56,5.39,27.72,5.78,34.18,7-2.41,12.86-4,16.47-4.22,0,0,59.68-13.48,103.67-14.56s66-2.13,66-2.13S355.11,195.71,344.57,174Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.93,278.94s-6.05,8.28-13.41,10.05c2.6,9.54,3.67,23.66,4,29,6.25-2.15,11.56-3.66,15.2-4.1.53-3.12.85-5.11.85-5.11Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.45,337.34c2.78.28,4.63,1.48,10.28.07,10-2.49,2.81-21.79,19.4-29.67a27.93,27.93,0,0,1,10.32-2.9,101.37,101.37,0,0,1,1-10.55,30.93,30.93,0,0,1,3-9.87c-4.53-1.39-5.35-2.72-13.07.95-16.6,7.88-14.11,28.21-24.06,30.7-7.94,2-8.38-1.19-14.41.29,2.82,4,5,11.79,7.2,20C129.28,336.73,129.36,337,129.45,337.34Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.12,320.25c-4.65,3.2-7.42,8-9,12.05A39.85,39.85,0,0,0,105.7,337c3.53,8.38,7.29,10.9,12.12,10.86a34.79,34.79,0,0,1-1.95-4.11C112.82,336.18,112,326.55,113.12,320.25Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.47,150l-1.81-.11c-72.93,18.66-102.6,106.56-112.81,148.92.55,4.21,1.15,8.34,1.8,12.36,1.24-.24.38,2.68,1.33,2.63,0,0,59.68-13.48,103.67-14.56s66-2.13,66-2.13S355.11,195.71,344.57,174,329.48,150.32,322.47,150Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.2,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.57,174c-10.54-21.75-15.09-23.64-22.1-24s-23.56-2.42-42,.53c0,0-51.44-.9-91.24,23.21-41.55,25.17-61.77,47.28-64.6,58.74s-12.49,41.32-17.07,58.44-7.7,32.2-1.86,46.06c3.53,8.38,7.29,10.9,12.12,10.86a34.79,34.79,0,0,1-1.95-4.11c-4.8-11.89-4.22-28.9,1.26-30s8.75,10.29,12.06,22.71a49.39,49.39,0,0,0,2.66,8c8.19-3.09,21.31-10,38.75-17.18a112.16,112.16,0,0,1-.11-32.92c2.58-17.07,13.49-20.84,18.24-10.45,3.93,8.56,5.39,27.72,5.78,34.18,7-2.41,12.86-4,16.47-4.22,0,0,59.68-13.48,103.67-14.56s66-2.13,66-2.13S355.11,195.71,344.57,174Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,283.76a4.68,4.68,0,0,0,5,.63c3.15-1.26,3.47-6,3.47-6l4.72-.31.95-14.81-10.4,4.09S127.22,281.87,126.27,283.76Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.63,327.07a51.8,51.8,0,0,0-8.43,5.6,38.63,38.63,0,0,0,1.5,4.31c3.53,8.38,7.29,10.9,12.12,10.86a34.79,34.79,0,0,1-1.95-4.11A48.54,48.54,0,0,1,112.63,327.07Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.56,318.81a1.51,1.51,0,0,1-1.32-.79,1.49,1.49,0,0,1,.6-2c.24-.13,19.7-12.19,35.82-20.76a1.5,1.5,0,1,1,1.41,2.65c-16.11,8.56-35.56,20.61-35.8,20.74A1.43,1.43,0,0,1,128.56,318.81Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,218.57l-.69,17.17c-.15,2.34,1.21,3.47,3,2.46l27.65-18a7.31,7.31,0,0,0,3.12-6.36l-.17-19.15c-.2-1.74-1.38-2.45-2.83-1.7-5.2,2.69-15.24,11.79-27.24,20.26A7.56,7.56,0,0,0,154,218.57Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.68,
    y1: 213.73,
    x2: 186.19,
    y2: 217.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154.2,
    y1: 238.28,
    x2: 162.54,
    y2: 219.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.16,218l12.26,1.53c1.27.19,2.85-.86,4-2.68l16-22.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.61,186.67l2.84,43a9.15,9.15,0,0,0,10.17,8.55l95.52-12.4a9.15,9.15,0,0,0,7.76-11.57l-12.06-42.64a9.13,9.13,0,0,0-9.46-6.63c-15.48,1.14-52.61,4.47-87.66,12.28A9.15,9.15,0,0,0,222.61,186.67Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.61,
    y1: 200,
    x2: 337.22,
    y2: 220.66,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.07,
    y1: 236.33,
    x2: 265.9,
    y2: 203.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.93,185.54l52.85,21.73A11.07,11.07,0,0,0,287.64,205l37.67-35.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 328.1,
    cy: 215.91,
    rx: 16.26,
    ry: 15.98,
    transform: "translate(-5.23 8.16) rotate(-1.41)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.33,223.56h-.05a2,2,0,0,1-1.62-.82l-6.39-8.82a2,2,0,0,1,3.24-2.35l4.77,6.58,11.4-15.75a2,2,0,0,1,3.24,2.35l-13,18A2,2,0,0,1,326.33,223.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.93,266.66s34-6.52,57.3-6.06l1.4,5.6s-48.92,2.32-58.24,7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.39,273.18l1,5.6a2.42,2.42,0,0,0,2.73,2c8.53-1.22,38.47-5.33,54-4.95a2.43,2.43,0,0,0,2.41-3.1l-1.86-6.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32,263.29l-.19-23.1,1.15-23.75a1.13,1.13,0,0,0-1.93-.84c-4.3,4.4-11.66,11.06-13.84,16.52-2.83,7.07-6.18,41.87-6.18,41.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.25,
    y: 258.65,
    width: 9.53,
    height: 23.44,
    rx: 3.09,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,242.53a22.68,22.68,0,0,1,4.62,1.41,12.08,12.08,0,0,1,3.31,2.4l5-6.61s-7.33-3.07-8.72-4.94l-1.38-1.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122,234.79,120.71,233l-.15.1-2.76,9.4s.53.1,1.28.28l7.15-5.18A14.67,14.67,0,0,1,122,234.79Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,242.53a22.68,22.68,0,0,1,4.62,1.41,12.08,12.08,0,0,1,3.31,2.4l5-6.61s-7.33-3.07-8.72-4.94l-1.38-1.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.36 236.92 122.25 244.71 123.08 247.36 132.39 237.69 128.36 236.92",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58,214.91c-4.13-3.2-14.89-1.16-17,6.42C100.28,226,101,233,101,233l12.26-2.6,1,1.51c2,3,6.33,1,7.45,0,.61-.53.57-2.09.41-3.38l.49-.11S122.7,218.12,118.58,214.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,229.48A39.35,39.35,0,0,0,98,231c-8,2.68-9.23,5-3.5,4.86S114,229.48,114,229.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.12,
    cy: 224.26,
    rx: 1.69,
    ry: 2.31,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13,240.19s-10.95-2.78-14.32-.22-4.23,6.79-3.15,11.92,3.71,18.62,3.71,18.62l13.95-7.22Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.75,268.36s-.59,5.18-1.28,5.91-18.89-14.56-20-16-.35-6.58,0-8.19-.24-2.49-2-1.38-1.29,5.73-1.29,5.73-5.37-1.29-6.44-1.44-2,1.18-1.84,2.24,1.57,1.15,1.57,1.15a8,8,0,0,0,.29,4.62c.94,1.94,2,3.16,4,3.64a33.33,33.33,0,0,0,6.24.38s9.3,8.86,12,12.17,8.39,7.81,11.22,7,5.53-14.94,5.53-14.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.47,274.27l5.32,1.77a4.73,4.73,0,0,1-3.26,5.22c-2.35.78-6.57-1.89-9.57-4.14l.09.11c2.75,3.32,8.39,7.81,11.22,7s5.53-14.94,5.53-14.94l-8.05-1S124.16,273.54,123.47,274.27Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.75,268.36s-.59,5.18-1.28,5.91-18.89-14.56-20-16-.35-6.58,0-8.19-.24-2.49-2-1.38-1.29,5.73-1.29,5.73-5.37-1.29-6.44-1.44-2,1.18-1.84,2.24,1.57,1.15,1.57,1.15a8,8,0,0,0,.29,4.62c.94,1.94,2,3.16,4,3.64a33.33,33.33,0,0,0,6.24.38s9.3,8.86,12,12.17,8.39,7.81,11.22,7,5.53-14.94,5.53-14.94Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.56 261.08 104 265.06 105.31 265.95 107.93 262.2 106.56 261.08",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.68,
    cy: 263.83,
    r: 1,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,234.28s.61,1.51,1.63,4.16,6.5,8.24,9.18,8.56,5.89-9.42,6.4-11.43c.17-.66.34-1.72.34-1.72s3.37-1.59,2.59-3.51-2.36-2.8-3.11-2.21-.88,3.08-2,3.1-1.73-.33-2.72-1.65S104.29,231,103.23,234.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-1--inject-11)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.52,229.58c-1-1.31-11.23,1.43-12.29,4.7l.58,1.48a44.59,44.59,0,0,1,12.6-5.17A6.33,6.33,0,0,1,115.52,229.58Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.24,230.07c-.82-1.72-2.27-2.5-3-1.94a5.91,5.91,0,0,0-1,2A20.75,20.75,0,0,1,123.24,230.07Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,234.28s.61,1.51,1.63,4.16,6.5,8.24,9.18,8.56,5.89-9.42,6.4-11.43c.17-.66.34-1.72.34-1.72s3.37-1.59,2.59-3.51-2.36-2.8-3.11-2.21-.88,3.08-2,3.1-1.73-.33-2.72-1.65S104.29,231,103.23,234.28Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.86,235c.18.61.12,1.17-.12,1.24s-.59-.37-.77-1-.12-1.17.12-1.24S106.68,234.41,106.86,235Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,233.3c1.4-.4,2,.65,2.17,1.62l.26,1.15.87,4.45,1.32-.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,233.64a2.87,2.87,0,0,1,2.43-.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.86,230.87a3,3,0,0,0-2.32,2.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.81,241.4s2.9-.58,3.13-2.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.43,275.86l-14.64-4.08s1.29-25,3.55-29.23c3.52-6.57,11.59-3.61,13.11,4.65C138.87,255,135.43,275.86,135.43,275.86Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.14,269s8,1.84,12.87,3.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,238.18s4.76.37,7.87,2.93",
    style: {
      fill: "none",
      stroke: "#92E3A9",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.69,302.13s-21.32,7.52-23.27,9.57-1.75,10.05,2.85,13.94,37.39-4.93,60.83-7.5S333,311.79,354,310.77s30.55,1.75,32.39-4.8S388,292.42,384,291,307.12,277.91,217.69,302.13Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.9,316.07s1,8.67,6.33,10,68.67-10.67,106-12,70-2.33,70-2.33",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.84,320.47c24.76-6,75.69-14.48,161.39-12.07",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.54,325.75s5.69-1.38,14.34-3.74",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.76,326.74a56.33,56.33,0,0,1-.3,11.15",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.85,166.83s-4.77,5.59-5.14,10.6",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.21,181.47s-3.59,57.11,5.91,117.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.34,247.46s-7.75,2.7-7.85,6.2c-.26,9.41.73,29.49,2.78,31.44s8.42-3.21,8.42-3.21,9,.78,10-1.24-2.75-30.45-3.31-32.93S203.34,247.46,203.34,247.46Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.22,261a17.06,17.06,0,0,0,6.45,1.7c-2.48-9.32-5.29-19.7-8.19-30.06-2.62-.18-6-.18-5.93,1C357.6,235.66,362.69,259.54,365.22,261Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.23,250.4s.34,18,1.67,25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.71,254.56s44.62-7.19,96.61,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.55,282.75c3.07.92,6.09,1.89,9,2.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.44,269.17s35.38,2.15,69.26,10.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76,351.56a329.87,329.87,0,0,1,88-1.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.1,346.85s20.94-2.62,27.75-3.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.34,152.63c3,.43,6,1,8.72,1.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.23,151.64a239.64,239.64,0,0,1,37,.25",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.89,272.78S205.77,258.63,249,254.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.21,246.83s18.09-4.71,45.61-6.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4,346.74a30.88,30.88,0,0,0,16.5,14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,351.24s4.5,7,10.5,10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.9,326.24s3,14,15,20",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.4,338.74a23.13,23.13,0,0,0,9.5,8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.56,365.7s3,5,13.5,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.56,368.7a24.13,24.13,0,0,0,13.5,5.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.74,356.36A423.4,423.4,0,0,0,180,368.14l.62.93s22-4.67,62.66,5.33,43.34,18,88,18,88-10.66,88-10.66l-5.42-3C373.76,361.77,318.8,353,258.74,356.36Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.74,356.36A423.4,423.4,0,0,0,180,368.14l.62.93s22-4.67,62.66,5.33,43.34,18,88,18,88-10.66,88-10.66l-5.42-3C373.76,361.77,318.8,353,258.74,356.36Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.9,379.24s52.5-8,98,22.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9,390.74s21.5,6.5,34.5,20.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.9,365.24s30.5,3,58,19.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,391.08a126.85,126.85,0,0,1,15.64,11.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.21,414.67c36.45-31,102.31-54,178.53-58.31,69.57-3.95,132.32,8.51,173,31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.4,364.74s31.5,1.5,52.5,8.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-1--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.58,127.34s-1-13.83-21.25-14.33-14.83,13.84-20.26,17.3-6.92-2-12.36,1.48-3,10.38-7.41,11.37-10.38-4.45-15.81-1-5.44,6.42-7.91,6.42-7.41-2-10.37,0S57.78,153,57.78,153h125s1.48-4.45-4-7.41-7.91-.5-9.88-3S174.4,133.77,159.58,127.34Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.85,74.41s-.6-8.32-12.78-8.62-8.92,8.33-12.19,10.41-4.16-1.19-7.43.89-1.78,6.24-4.46,6.83-6.24-2.67-9.51-.59-3.27,3.86-4.76,3.86-4.46-1.18-6.24,0-3.86,2.68-3.86,2.68h75.2s.89-2.68-2.38-4.46-4.75-.3-5.94-1.78S242.77,78.28,233.85,74.41Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.58,127.34s-1-13.83-21.25-14.33-14.83,13.84-20.26,17.3-6.92-2-12.36,1.48-3,10.38-7.41,11.37-10.38-4.45-15.81-1-5.44,6.42-7.91,6.42-7.41-2-10.37,0S57.78,153,57.78,153h125s1.48-4.45-4-7.41-7.91-.5-9.88-3S174.4,133.77,159.58,127.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.85,74.41s-.6-8.32-12.78-8.62-8.92,8.33-12.19,10.41-4.16-1.19-7.43.89-1.78,6.24-4.46,6.83-6.24-2.67-9.51-.59-3.27,3.86-4.76,3.86-4.46-1.18-6.24,0-3.86,2.68-3.86,2.68h75.2s.89-2.68-2.38-4.46-4.75-.3-5.94-1.78S242.77,78.28,233.85,74.41Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSend);
export default __webpack_public_path__ + "static/media/MailSend.25231f91249f5d2ea65952a45f31be7b.svg";
export { ForwardRef as ReactComponent };